const list_coins = {
  usd:    'Virtual USD',
  vusd:   'Virtual USD',
  vmxn:   'Virtual MXN',
  btc:    'Bitcoin',
  ltc:    'Litecoin',
  dash:   'Dash',
  eth:    'Ethereum',
  xrp:    'Ripple',
  usdt:   'Tether',
  sol:    'Solana',
  bch:    'Bitcoin Cash',
  trx:    'Tron',
}

export default list_coins